import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function SiteHeader() {
  return (
    <>
      <header
        data-testid="preregistration-sticky-header"
        className="sticky top-0 z-30 bg-white shadow-[0_1px_0_rgba(15,23,42,0.06),0_8px_24px_rgba(15,23,42,0.06)]"
      >
        <div className="tricolor-bar" />
        <div className="mx-auto flex max-w-3xl flex-col items-center px-6 pb-3 pt-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="brand-logo text-[26px] sm:text-[30px]"
            data-testid="preregistration-brand-logo"
          >
            <span className="text-[#2b46c4]">PASS</span>
            <span className="text-[#101a33]">PRO</span>
            <span className="text-[#e0312e]">FRANCE</span>
          </motion.div>
          <p className="mt-1 text-[10.5px] font-medium uppercase tracking-[0.3em] text-slate-400" data-testid="preregistration-brand-tagline">
            France Administrative
          </p>
        </div>
      </header>
      <div data-testid="preregistration-hero" className="mx-auto flex max-w-3xl flex-col items-center px-6 pb-4 pt-4 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1, ease: "easeOut" }}
          className="text-lg font-bold text-[#101a33] sm:text-xl"
          data-testid="preregistration-hero-title"
        >
          Pré-Enregistrement de souscription
        </motion.h1>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mt-3"
        >
          <Link
            to="/cgv"
            className="text-[13px] font-medium italic text-[#2b46c4] underline decoration-[#2b46c4]/50 underline-offset-4 transition-colors duration-200 hover:decoration-[#2b46c4]"
            data-testid="preregistration-cgc-lien"
          >
            Conditions Générales Contractuelles
          </Link>
        </motion.div>
      </div>
    </>
  );
}
